import { TENANT_CODE } from 'libs/constants';
import { getPackageApiBaseUrl } from 'libs/env';
import { ApiClient } from './api-client';
import { ApiParams, FooterSetting } from './types';

/**
 * フッターの設定を取得する
 *
 * 指定された `baseUrl`、`tenantCode` を使用してAPIからフッターの設定を取得します。
 *
 * @param {UnseenCouponApiParams} params - APIリクエストに必要なパラメータ
 * @param {string} params.baseUrl - APIのベースURL
 * @param {string} params.tenantCode - テナントコード
 * @returns {Promise<FooterSetting>} フッター設定
 *
 * @example
 * ```typescript
 * const count = await invokeFooterSettingApi({
 *   baseUrl: 'https://package.digiclueapp.com',
 *   tenantCode: 'tenant123'
 * });
 * ```
 */
const invokeFooterSettingApi = async ({
  baseUrl,
  tenantCode
}: ApiParams): Promise<FooterSetting> => {
  const client = new ApiClient({ baseUrl });
  try {
    const response = await client.call({ tenantCode });
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    // TODO: 設定をLocalStorageにいれておき、エラー発生時はそっちから読み出すようにしたほうがいいかも
    console.debug(error);
  }

  // エラー発生時等は空配列を返す
  return {
    navis: []
  };
};

/**
 * [外部インターフェース]
 * フッターの設定を取得する
 *
 * フッター設定が未設定やAPIエラー発生時は空配列を返すため、未設定のときと同じ動きにfallbackすること
 */
export const fetchFooterSetting = async (): Promise<FooterSetting> => {
  const baseUrl = getPackageApiBaseUrl();
  const tenantCode = TENANT_CODE;
  return invokeFooterSettingApi({ baseUrl, tenantCode });
};
